module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gd-1b313417e54a6f4446ee51fb4cfaf958.svg";